import { styled, Modal as MuiModal } from '@mui/material';

export const StyledModal = styled(MuiModal)(() => ({
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  width: '100%',
  overflow: 'auto',
  zIndex: 'var(--zindex-modal)',
  '& .dialog-content': {
    background: 'var(--surface-bg-color)',
    borderRadius: 'var(--border-radius-6)',
    boxShadow: 'var(--shadow-dropdown)',
    position: 'relative'
  },
  '& .dialog-header--absolute': {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    paddingTop: 'var(--spacer-8)',
    paddingRight: 'var(--spacer-8)'
  },
  '& .primary': {
    width: '500px',
    maxWidth: '100%'
  },
  '&.top-align': {
    alignItems: 'flex-start',
    '& .dialog-content': {
      width: '512px',
      marginTop: '120px'
    }
  },
  '&.center-align': {
    '& .dialog-content': {
      margin: 'auto'
    }
  }
}));
